import { CommonResponseModel } from '@needle-management/shared-models';
import { Injectable } from '@nestjs/common';
import { NeedleReturnProductionRepository } from './needle-return-after-production.repo';
import { NeedleReturnAfterProductionDto } from './needle-return-after-production.dto';
import { NeedleReturnAfterProductionEntity } from './needle-return-after-production.entity';
import { ReturnStatusEnum } from '@needle-management/shared-models';
import { MaterialRequestRepository } from '../material-request/material-request-repo';
import { StockOutRepository } from '../stock-in/repositories/stock-out.repository';
@Injectable()
export class NeedleReturnAfterProductionService {
    constructor(
        private needleReturnProductionRepo: NeedleReturnProductionRepository,
        private stockOutRepository: StockOutRepository,

    ) { }

    async createNeedleReturnProduction(req: NeedleReturnAfterProductionDto): Promise<CommonResponseModel> {
        try {
            console.log(req);
            const entity = new NeedleReturnAfterProductionEntity();
            entity.jobId = req.jobId;
            entity.returnQty = req.returnQty;
            entity.returnTo = req.returnTo;
            entity.returnBy = req.returnBy;
            entity.remainingQty = req.remainingQty;
            entity.noOfPieces = req.noOfPieces;
            entity.returnPurpose = req.returnPurpose;   
            entity.shifts = req.shifts;
            entity.dateOfReturn = req.dateOfReturn;
           
            const save = await this.needleReturnProductionRepo.save(entity);
            if (save) {
                let status = ReturnStatusEnum.Received;
                if(Number(req.remainingQty) > 0){
                    status = ReturnStatusEnum.PartiallyReceived;
                }
                let updateFlag = true
                let updateReturnStatus = await this.stockOutRepository.update({id:req.jobId},{returnStatus:status})
                if(!updateReturnStatus.affected){
                    updateFlag = false
                }
                if(updateFlag){
                    return new CommonResponseModel(true, 1, 'Created successfully', save);
                }else {
                    return new CommonResponseModel(false, 0, 'Something went wrong in Needle Return Production creation', []);
                }
                
            } else {
                return new CommonResponseModel(false, 0, 'Something went wrong in Needle Return Production creation', []);
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllNeedleReturnProduction(): Promise<CommonResponseModel> {
        const result = await this.needleReturnProductionRepo.getAllNeedleReturnProductionQuery()
        if (result.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', result);
        }
        return new CommonResponseModel(true, 1, 'No data found', []);
    }

    async getAllNeedleReturnReport(req:any): Promise<CommonResponseModel> {
        const result = await this.needleReturnProductionRepo.getAllNeedleReturnReport(req)
        if (result.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', result);
        }
        return new CommonResponseModel(true, 1, 'No data found', []);
    }

    


    async getActiveNeedleReturnProduction(): Promise<CommonResponseModel> {
        const data = await this.needleReturnProductionRepo.find({ where: { isActive: true } });
        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
        }
        return new CommonResponseModel(true, 1, 'No active Needle Return data found', []);
    }

    async deleteNeedleReturnProduction(req: NeedleReturnAfterProductionDto): Promise<CommonResponseModel> {
        try {
            const result = await this.needleReturnProductionRepo.delete(
                { id: req.id },
            );

            if (result.affected > 0) {
                return new CommonResponseModel(true, 1, 'Deleted successfully', result);
            } else {
                return new CommonResponseModel(false, 0, 'Deleted failed', []);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async updateNeedleReturnProduction(req: NeedleReturnAfterProductionDto): Promise<CommonResponseModel> {
        try {
            const result = await this.needleReturnProductionRepo.update(
                { id: req.id },
                { 
                    jobId: req.jobId,
                    returnQty: req.returnQty,  
                    returnTo: req.returnTo,
                    returnBy: req.returnBy,
                    updatedUser: req.updatedUser, 
                    isActive: req.isActive }
            );
            if (result.affected > 0) {
                return new CommonResponseModel(true, 1, 'Updated successfully', result);
            } else {
                return new CommonResponseModel(false, 0, 'Update failed', []);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivateNeedleReturnProduction(req: NeedleReturnAfterProductionDto): Promise<CommonResponseModel> {
        try {
            const exists = await this.needleReturnProductionRepo.findOne({ where: { id: req.id } });
            if (!exists) {
                throw new CommonResponseModel(false, 99998, 'No Needle Return Production found');
            }
            const update = await this.needleReturnProductionRepo.update(
                { id: req.id },
                { isActive: req.isActive, updatedUser: req.updatedUser }
            );
            if (exists.isActive && !req.isActive) {
                if (update.affected) {
                    return new CommonResponseModel(true, 1, 'Needle Return Production deactivated successfully');
                } else {
                    throw new CommonResponseModel(false, 0, 'Needle Return Production already deactivated');
                }
            } else if (!exists.isActive && req.isActive) {
                if (update.affected) {
                    return new CommonResponseModel(true, 1, 'Needle Return Production  activated successfully');
                } else {
                    throw new CommonResponseModel(false, 0, 'Needle Return Production  already activated');
                }
            } else {
                return new CommonResponseModel(false, 0, 'No changes were made');
            }
        } catch (err) {
            return err;
        }
    }
}
